const constantes = {
  nfPagamentosList: [
    { value: "fpDinheiro", label: "Dinheiro" },
    { value: "fpCheque", label: "Cheque" },
    { value: "fpCartaoCredito", label: "Cartão Crédito" },
    { value: "fpCartaoDebito", label: "Cartão Débito" },
    { value: "fpCreditoEmLoja", label: "Crédito Loja" },
    { value: "fpValeAlimentacao", label: "Vale Alimentação" },
    { value: "fpValeRefeicao", label: "Vale Refeição" },
    { value: "fpValePresente", label: "Vale Presente" },
    { value: "fpValeCombustivel", label: "Vale Combustível" },
    { value: "fpDuplicataMercantil", label: "Duplicata Mercantil" },
    { value: "fpBoletoBancario", label: "Boleto" },
    { value: "fpDepositoBancario", label: "Depósito" },
    { value: "fpPagamentoInstantaneoPIXEstatico", label: "Pix Estático" },
    { value: "fpPagamentoInstantaneoPIXDinamico", label: "Pix Dinâmico" },
    { value: "fpTransferenciabancaria", label: "Transferência Bancária" },
    { value: "fpProgramadefidelidade", label: "CashBack/Crédito Virtual" },
    { value: "fpSemPagamento", label: "Sem Pagamento" },
    { value: "fpOutro", label: "Outros" },
  ],
  modalidadeTefList: [
    { value: '0', label: "Manualmente" },
    { value: '1', label: "Cheque" },
    { value: '2', label: "Cartão de Débito" },
    { value: '3', label: "Cartão de Crédito" },
    { value: '122', label: "Carteira Digital" },
    { value: '4', label: "Fininvest" },
    { value: '5', label: "Cartão Beneficio" },
    { value: '6', label: "Crédito Centralizado" },
    { value: '7', label: "Cartão Combustivel" },
    { value: '8', label: "Mais Redecard" },
    { value: '10', label: "Beneficio Refeição" },
    { value: '11', label: "Beneficio Alimentação" },
    { value: '12', label: "Cartão Infocard" },
    { value: '13', label: "PayPass" },
    { value: '14', label: "Cartão NTPC" },
    { value: '15', label: "Venda com Cartão Gift" },
    { value: '16', label: "Débito com Pagamento de Carnê" },
  ],
};

export default constantes;
